import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [cancelingRequest, setCancelingRequest] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const [selectedRowToConfirm, setSelectedRowToConfirm] = useState(null);

  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  return {
    loading,
    setLoading,
    cancelingRequest,
    setCancelingRequest,
    isConfirmOpen,
    setIsConfirmOpen,
    selectedRowToDelete,
    setSelectedRowToDelete,
    filterParams,
    setFilterParams,
    size,
    setSize,
    page, setPage,
    selectedRowToConfirm,
    setSelectedRowToConfirm,
  };
};

export default useCustomHook;
